import { dxtToLocalServerTime } from "@dexteel/mesf-core";
import {
  ColDef,
  ColGroupDef,
  ICellRendererParams,
  ValueGetterParams,
} from "ag-grid-enterprise";
import { EditAndDeleteButtons } from "../../../../../../../shared/data-entries/EditAndDeleteButtons";
import { ManualAutoButton } from "../../../../../../../shared/data-entries/ManualAutoButton";
import { Charge } from "../../../../models/eaf.models";

type Props = {
  deleteCharge: (chargeId: number) => void;
  editCharge: (chargeId: number) => void;
};

export const useTableData = ({ deleteCharge, editCharge }: Props) => {
  const columns: ColGroupDef[] = [
    {
      headerName: "Charges",
      children: [
        {
          field: "manual-auto",
          headerName: " ",
          flex: 1,
          cellRenderer: ManualAutoButton,
          cellRendererParams: (params: ICellRendererParams<Charge>) => ({
            isManual: (params.data as Charge).IsChargeManual,
          }),
        },
        {
          field: "Timestamp",
          headerName: "Time",
          flex: 2,
          valueGetter: (params: ValueGetterParams<Charge>) => {
            if (params.data?.Timestamp) {
              return dxtToLocalServerTime(
                (params.data as Charge).Timestamp,
                "HH:mm",
              );
            }
          },
        },
        {
          field: "BucketName",
          headerName: "Bucket",
          flex: 2,
        },
        {
          field: "Weight",
          headerName: "Weight [lbs]",
          flex: 2,
          valueGetter: (params: ValueGetterParams<Charge>) =>
            params.data?.Weight?.toFixed(0) || "0",
        },
        {
          field: "Lime",
          headerName: "Lime [lbs]",
          flex: 2,
          valueGetter: (params: ValueGetterParams<Charge>) =>
            params.data?.Lime?.toFixed(0) || "0",
        },
        {
          field: "actions",
          headerName: " ",
          flex: 2,
          cellRenderer: EditAndDeleteButtons,
          cellRendererParams: (params: ICellRendererParams<Charge>) => ({
            deleteItem: deleteCharge,
            onEdit: editCharge,
            id: (params.data as Charge).ChargeId,
          }),
        },
      ],
    },
  ];

  return { columns };
};
